<template>
<b-tabs
  nav-class="material px-3"
  :content-class="contentClass"
  class="h-100 d-flex flex-column tabs-material overflow-hidden"
  @input="evh_7315092382398562_input($event, {})"
>
  <slot>
  </slot>
  <template
    slot="tabs-start"
  >
    <slot
      name="tabs-start"
    >
    </slot>
  </template>
  <template
    slot="tabs-end"
    v-if="closeButton"
  >
    <button
      data-dismiss="modal"
      aria-label="Close"
      class="close ml-auto mr-2"
      @click="evh_1548630417156826_click($event, {})"
    >
      <span aria-hidden="true">&times;</span>

    </button>
  </template>
</b-tabs>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class MaterialTabs extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: Boolean,
  })
  closeButton!: boolean;

  @Watch('closeButton')
  onClose_button(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("closeButton")
  }

  @Prop({
    type: Object,
  })
  tabManager!: object;

  @Watch('tabManager')
  onTab_manager(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("tabManager")
  }

  @Prop({
    type: Boolean,
  })
  noContentWrapper!: boolean;

  @Watch('noContentWrapper')
  onNo_content_wrapper(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("noContentWrapper")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  get contentClass() {
    if (this.loaded) {

      return this.noContentWrapper
        ? 'flex-fill overflow-hidden h-100'
        : 'flex-fill overflow-auto px-3 py-4 h-100 bg-page'
    }
    return null;
  }

  async act_7315092382398562_emit_2402_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7315092382398562_emit_2402, alias=undefined
    return {
      event: "input",
      value: {
        tabIndex: $event.originalEvent,
      }
      ,
    }
  }

  async act_7315092382398562_script_2404_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7315092382398562_script_2404, alias=undefined
    this.tabManager.visited($event.originalEvent, true)
  }

  async act_7315092382398562_script_2404_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_2404, alias=undefined
    return {
      value: () => this.act_7315092382398562_script_2404_getActionArgs_value($event),
    }
  }

  async act_7315092382398562_script_2404_getWhen($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_2404, alias=undefined
    return !!this.tabManager
  }

  async act_7315092382398562_script_2406_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7315092382398562_script_2406, alias=undefined
    this.$root.$emit('slickgrid:resize', { resetScrollPosition: true })
  }

  async act_7315092382398562_script_2406_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_2406, alias=undefined
    return {
      value: () => this.act_7315092382398562_script_2406_getActionArgs_value($event),
    }
  }

  async evh_7315092382398562_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_input.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_emit_2408_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1548630417156826_emit_2408, alias=undefined
    return {
      event: "close",
    }
  }

  async evh_1548630417156826_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_emit_2402: actions.EmitAction;
    evh_7315092382398562_input_2401: actions.EventHandlerImpl;
    act_7315092382398562_script_2404: actions.ScriptAction;
    evh_7315092382398562_input_2403: actions.EventHandlerImpl;
    act_7315092382398562_script_2406: actions.ScriptAction;
    evh_7315092382398562_input_2405: actions.EventHandlerImpl;
    evh_7315092382398562_input: actions.EventHandlerGroup;
    act_1548630417156826_emit_2408: actions.EmitAction;
    evh_1548630417156826_click_2407: actions.EventHandlerImpl;
    evh_1548630417156826_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_emit_2402 = new actions.EmitAction(
      {
        actionArgs: this.act_7315092382398562_emit_2402_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_input_2401 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_emit_2402,
        event: "input",
        displayName: "emit",
      }
    );
    const act_7315092382398562_script_2404 = new actions.ScriptAction(
      {
        actionArgs: this.act_7315092382398562_script_2404_getActionArgs,
        when: this.act_7315092382398562_script_2404_getWhen,
        events: [],
      }
    );
    const evh_7315092382398562_input_2403 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_script_2404,
        event: "input",
        displayName: "script",
      }
    );
    const act_7315092382398562_script_2406 = new actions.ScriptAction(
      {
        actionArgs: this.act_7315092382398562_script_2406_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_input_2405 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_script_2406,
        event: "input",
        displayName: "script",
      }
    );
    const evh_7315092382398562_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_input_2401, evh_7315092382398562_input_2403, evh_7315092382398562_input_2405],
      }
    );
    const act_1548630417156826_emit_2408 = new actions.EmitAction(
      {
        actionArgs: this.act_1548630417156826_emit_2408_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_click_2407 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_emit_2408,
        event: "click",
        displayName: "emit",
      }
    );
    const evh_1548630417156826_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_click_2407],
      }
    );
    return {
      act_7315092382398562_emit_2402,
      evh_7315092382398562_input_2401,
      act_7315092382398562_script_2404,
      evh_7315092382398562_input_2403,
      act_7315092382398562_script_2406,
      evh_7315092382398562_input_2405,
      evh_7315092382398562_input,
      act_1548630417156826_emit_2408,
      evh_1548630417156826_click_2407,
      evh_1548630417156826_click,
    }
  }
}

Vue.component("MaterialTabs", MaterialTabs);

</script>